module.exports = __webpack_public_path__ + "img/81600.ab690688.jpg";